<template>
  <a-modal
    class="modal-content"
    :title="title || form.id ? '编辑' : '创建'"
    :width="870"
    :visible="visible"
    destroyOnClose
    ok-text="保存"
    @ok="handleOk"
    @cancel="hideModal"
  >
    <template>
      <a-form-model
        ref="ruleForm"
        :labelCol="{ span: 3 }"
        :wrapperCol="{ span: 20 }"
        :model="form"
        :rules="rules"
      >
        <a-form-model-item v-if="currKeysFormArr.includes('title')" label="标题" prop="title">
          <a-input v-model="form.title" placeholder="请输入标题" />
        </a-form-model-item>
        <a-form-model-item
          v-if="
            !currKeysFormArr.includes('applicableGrade') && currKeysFormArr.includes('classify')
          "
          label="选择分类"
          prop="classify"
        >
          <j-dict-select-tag
            placeholder="请选择分类"
            v-model="form.classify"
            :dictCode="cateDictCode"
            allowClear
          />
        </a-form-model-item>
        <a-row
          v-if="currKeysFormArr.includes('applicableGrade') && currKeysFormArr.includes('classify')"
          :gutter="0"
          style="padding: 0 20px"
        >
          <a-col :span="12">
            <a-form-model-item
              label="适用年级"
              prop="applicableGrade"
              :labelCol="{ ...itemLabelCol }"
              :wrapperCol="itemWrapperCol"
            >
              <j-dict-select-tag
                placeholder="请选择年级"
                v-model="form.applicableGrade"
                :dictCode="gradeDictCode"
                allowClear
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              label="选择分类"
              prop="classify"
              :labelCol="itemLabelCol"
              :wrapperCol="itemWrapperCol"
            >
              <j-dict-select-tag
                placeholder="请选择分类"
                v-model="form.classify"
                :dictCode="cateDictCode"
                allowClear
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item v-if="currKeysFormArr.includes('cover')" label="上传封面" prop="cover">
          <div class="flex-align-center">
            <j-image-upload
              ref="coverRef"
              accept=".png,.jpg,.jpeg"
              v-model="form.cover"
              :bizPath="bizPath"
              @change="imgChange"
            />
            <span style="color: #cdcdcd">*建议封面尺寸444 * 252，大小不超过500kb</span>
          </div>
        </a-form-model-item>
        <a-form-model-item
          v-if="currKeysFormArr.includes('courseDesc')"
          label="简介"
          prop="courseDesc"
        >
          <a-textarea
            v-model="form.courseDesc"
            placeholder="请输入简介"
            :auto-size="{ minRows: 3, maxRows: 5 }"
          />
        </a-form-model-item>
        <a-form-model-item v-if="currKeysFormArr.includes('file')" label="附件" prop="file">
          <div class="flex-align-center">
            <JUpload
              :accept="this.acceptSuffix"
              fileType="file"
              :value="filePath"
              @change="fileChange"
              :bizPath="bizPath"
            />
            <span style="margin-left: 10px; color: #cdcdcd">
              *{{ this.acceptSuffix === '.zip' ? '仅可上传zip压缩包' : '仅可上传文档和PPT' }}
            </span>
          </div>
        </a-form-model-item>
        <a-form-model-item
          v-if="currKeysFormArr.includes('content')"
          label="详细介绍"
          prop="content"
        >
          <WangEditor
            v-model="form.content"
            :editorStyle="{ minHeight: '200px' }"
            style="margin: 2px; border: 1px solid #d9d9d9; border-radius: 4px; overflow: hidden"
          />
        </a-form-model-item>
      </a-form-model>
    </template>
  </a-modal>
</template>

<script>
import WangEditor from '@comp/WangEditor/index.vue'
import JImageUpload from '@comp/jeecg/JImageUpload.vue'
import JUpload from '@comp/jeecg/JUpload.vue'
import { postAction, putAction } from '@/api/manage'
import { getFileSuffix } from '@/utils/util'

export default {
  name: 'CreateCourseModal',
  components: {
    WangEditor,
    JImageUpload,
    JUpload,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    activeKey: {
      type: [String, Number],
      default: undefined,
    },
    isShowSort: {
      type: Boolean,
      default: false,
    },
    cateDictCode: {
      type: String,
      default: '',
    },
    gradeDictCode: {
      type: String,
      default: '',
    },
    bizPath: {
      type: String,
      default: 'resourceCource',
    },
    actionUrl: {
      type: String,
      default: '',
    },
    // 控制显示哪些表单
    keysFormArr: {
      type: Array,
      default: () => [],
    },
    // 上传文件后缀
    acceptSuffix: {
      type: String,
      default: '.doc,.docx,.ppt,.pptx',
    },
    // 新增编辑操作时，文件对应的key
    fileUploadKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
      current: 1,
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
      itemLabelCol: { span: 5 },
      itemWrapperCol: { span: 18 },
      filePath: '',
      form: {},
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        classify: [{ required: true, message: '请选择分类', trigger: 'blur' }],
        applicableGrade: [{ required: true, message: '请选择适用年级', trigger: 'blur' }],
        courseDesc: [{ required: true, message: '请输入简介', trigger: 'blur' }],
      },
      currEvalInfo: {},
      currKeysFormArr: [],
    }
  },
  methods: {
    showModal(data) {
      console.log('fileUploadKey', this.fileUploadKey)
      if (!this.keysFormArr.length) {
        this.currKeysFormArr = ['title', 'classify', 'cover', 'courseDesc', 'file', 'content']
      } else {
        this.currKeysFormArr = [...this.keysFormArr]
      }
      console.log('显示表单key', this.currKeysFormArr)
      this.visible = true
      if (!data) return
      this.form = {
        id: data.id,
        title: data.title,
        cover: data?.cover,
        applicableGrade: data?.applicableGrade,
        classify: data?.classify,
        content: data?.content,
        courseDesc: data?.courseDesc,
      }
      this.filePath = data?.wordFile || data?.pptFile || data?.file
    },
    hideModal() {
      this.visible = false
      this.current = 1
      this.form = {}
      this.filePath = ''
    },
    fileChange(value) {
      this.filePath = value
      // console.log('文件路径：', this.filePath)
    },
    imgChange(info) {
      // console.log('图片信息：', info)
    },
    handleOk() {
      console.log('点击保存')
      this.$refs.ruleForm.validate(async (valid) => {
        console.log('验证状态：', valid)
        if (!valid) return
        const cover = this.$refs['coverRef'].fileList.map((file) => {
          return { name: file.oldName, pic: file.response.message }
        })
        const params = {
          ...this.form,
          type: this.activeKey,
        }
        if (cover?.[0]?.pic) {
          params.cover = cover?.[0]?.pic
        }
        if (this.filePath) {
          console.log('文件路径：', this.filePath)
          const suffix = getFileSuffix(this.filePath)
          let fileType
          if (this.fileUploadKey) {
            fileType = this.fileUploadKey
          } else {
            fileType = ['doc', 'docx'].includes(suffix)
              ? 'wordFile'
              : ['ppt', 'pptx'].includes(suffix)
              ? 'pptFile'
              : 'file'
          }
          params[fileType] = this.filePath
        }
        const actionUrl = this.actionUrl.replace('/', '')
        const res = this.form.id
          ? await putAction(`/${actionUrl || this.bizPath}/edit`, params)
          : await postAction(`/${actionUrl || this.bizPath}/add`, params)
        console.log('创建：', res)
        if (res.success) {
          this.$message.success(res?.message || '创建成功')
          this.$emit('refreshData')
          this.hideModal()
        } else {
          this.$message.error(res?.message || '创建失败')
        }
      })
    },
  },
}
</script>
<style scoped lang="less">
.modal-content {
  /deep/ .ant-upload-picture-card-wrapper {
    width: auto;
  }
}
</style>
